import { mediaQueryStyles } from "@newsela/angelou";

const { mediaQuery: breakpoint } = mediaQueryStyles;

export const containerCss = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-end",
  gap: 20,
  [breakpoint.downTo("sm")]: {
    flexDirection: "row",
  },
};

export const inputCss = {
  root: {
    [breakpoint.downTo("sm")]: {
      maxWidth: 410,
    },
  },
  underInput: {
    display: "none",
  },
};

export const buttonCss = {
  root: {
    width: "100%",
    height: "100%",
    [breakpoint.downTo("sm")]: {
      width: "auto",
    },
  },
};
